module.exports = __webpack_public_path__ + "media/signup-react/check-08537c0d.png";